// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4od0v","paddingBottom":"styles_paddingBottom__4g8k2","ctaBtn":"styles_ctaBtn__BqEmG"};